import styled from 'styled-components';
import theme from '../../styles/theme';

export const CustomButton = styled.button`
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 300px;
  max-width: 200px;
  border-radius: 50px;
  border: none;
  text-transform: uppercase;
  color: ${({ blackText }) => (blackText ? theme.background : theme.accent)};
  font-size: 16px;
  font-weight: normal;
  cursor: pointer;
  align-self: center;
  margin: 20px 0;
  opacity: ${({ isLoading }) => (isLoading ? 0.5 : 1)};
  background-color: ${({ primary, secondary, color }) => {
    if (color.length > 0) {
      return color;
    }
    if (primary) {
      return theme.primary;
    }
    if (secondary) {
      return theme.secondary;
    }

    return theme.background;
  }};

  @media (max-width: 400px) {
    margin: 5px 0;
  }
`;
